import { nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../../Translations';
import Checkmark from '../../../../../../../../../Cutesies/Checkmark';
import CopyIcon from '../../../../../../../../../Cutesies/CopyIcon';
import Loader from '../../../../../../../../../Loader';

export interface Props {
  kind: 'waiting' | 'copying' | 'copied';
  copying: () => void;
}

function CopyToClipboardState({ kind, copying }: Props) {
  switch (kind) {
    case 'waiting':
      return (
        <span
          onClick={copying}
          className="cursor-pointer flex items-center justify-center w-26 h-6"
        >
          <CopyIcon />
          <span className="ml-1">
            <T kind={'Copy Deep Link'} />
          </span>
        </span>
      );
    case 'copying':
      return (
        <div className="">
          <Loader type="spin" text={nothing()} height={24} width={24} color="#187A90" />
        </div>
      );
    case 'copied':
      return (
        <div className="flex items-center justify-center w-26 h-6">
          <Checkmark className="fill-teal-600" />
          <span className="ml-1">
            <T kind={'Copy Deep Link'} />
          </span>
        </div>
      );
  }
}

export default observer(CopyToClipboardState);
